import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StaticIcon from '../StaticIcon';
var CloseButton = styled.button.attrs(function (_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 15 : _ref$iconSize,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? React.createElement(StaticIcon, {
    type: "close",
    size: iconSize
  }) : _ref$children,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Close' : _ref$ariaLabel;
  return {
    type: type,
    iconSize: iconSize,
    children: children,
    'aria-label': ariaLabel
  };
}).withConfig({
  displayName: "CloseButton",
  componentId: "x5ivsk-0"
})(["\n  position: absolute;\n  top: 0;\n  ", ";\n  width: 56px;\n  height: 56px;\n  border: 0;\n  line-height: 56px;\n  text-align: center;\n  background: transparent;\n  cursor: pointer;\n"], function (props) {
  return props.align === 'left' ? 'left: 0' : 'right: 0';
});
CloseButton.propTypes = {
  /**
   * The size of the default icon to render (if you don't pass your own
   * `children`).
   */
  iconSize: PropTypes.number,

  /**
   * The content of the close button, usually an icon. If none is provided,
   * the default close icon is rendered.
   */
  children: PropTypes.node
};
/** @component */

export default CloseButton;